import { makeServicesTypesFromEnum } from '@/core/container/makeServicesTypes'

export enum CONTACT_GROUPING_ITEM_SERVICES {
  ContactGroupingItemService,
  ContactGroupingItemRepository,
  ContactListFolderService,
  ContactListFolderRepository,
  ContactGroupingItemColumnServiceFactory,
  ContactGroupingItemVisibilityColumnServiceFactory,
  ContactListFolderFormService,
  ContactGroupingItemsDeleteFormService,
  ContactGroupingItemsDeletePreviewResolver,
  ContactListFolderSummaryService,
  ContactListFolderSummaryRepository,
  ContactListFolderSummaryResolver,
  ContactListFolderTreeNodeService,
  ContactListFolderTreeNodeRepository,
  ContactGroupingItemGridableFactory,
}

export type ContactGroupingItemServices = keyof typeof CONTACT_GROUPING_ITEM_SERVICES

export const CONTACT_GROUPING_ITEM_SERVICES_TYPES =
  makeServicesTypesFromEnum<ContactGroupingItemServices>(CONTACT_GROUPING_ITEM_SERVICES)
